var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShotBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25,46.82,10.11,41,8.46,40A1.15,1.15,0,0,0,6.7,41l.56,5.91a1,1,0,0,0,1.06.89L29,45.88A2,2,0,0,0,29.43,42L16.07,37.65a5.77,5.77,0,0,1-3.65,3.23,5.15,5.15,0,0,1-2.59-.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.75,
    y1: 40.33,
    x2: 23.24,
    y2: 46.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.94,
    y1: 40.88,
    x2: 25.31,
    y2: 42.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.46,
    y1: 40.16,
    x2: 22.83,
    y2: 41.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.1,
    y1: 39.32,
    x2: 20.47,
    y2: 41.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7,
    y1: 38.54,
    x2: 18.07,
    y2: 40.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.74,
    y1: 47.62,
    x2: 28.58,
    y2: 45.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.05,
    y1: 47.97,
    x2: 24.89,
    y2: 46.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.36,
    y1: 48.31,
    x2: 21.2,
    y2: 46.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.39,
    y1: 49.06,
    x2: 13.23,
    y2: 47.36,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7,
    y1: 49.4,
    x2: 9.54,
    y2: 47.7,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 39.69,
    x2: 4.92,
    y2: 33.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.49,
    y1: 38.07,
    x2: 10.93,
    y2: 29.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.29,15.9v3.91A1.14,1.14,0,0,0,23.44,21h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.41 21.93 27.41 24.05 24.64 24.05 24.64 20.71 24.64 19.91",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.41,24.05v6.47A1.39,1.39,0,0,1,26,31.91h0a1.38,1.38,0,0,1-1.38-1.39V24.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.41 24.05 30.18 24.05 30.18 19.91",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.45,24.77l2,2.68v2.6a1.39,1.39,0,0,0,1.39,1.39h0a1.39,1.39,0,0,0,1.38-1.39V26.59l-1.2-1.65",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.21,
    cy: 4.18,
    r: 2.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.26,10.39a3.12,3.12,0,0,0-2.19-1.07h-.62a2.28,2.28,0,0,1-1.24.36A2.24,2.24,0,0,1,26,9.31h-.58a3.09,3.09,0,0,0-3.09,3.1V15.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,15.9v3.91A1.14,1.14,0,0,1,30.86,21h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,15.9V12.41a3.09,3.09,0,0,0-3.09-3.1h0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.44,
    y1: 20.96,
    x2: 23.81,
    y2: 20.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.68,39.8c.16-.35.31-.7.45-1.08A21.21,21.21,0,0,0,32.4,33.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.46,27.38a33,33,0,0,1-.56,5.22c-.22,1.15-.49,2.22-.77,3.18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.73,18.53q1.25-.47,2.7-.87a35.59,35.59,0,0,1,4-.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.34,14.26l2.74,2.55-1.71,3.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,16.73a8.75,8.75,0,0,0-1-1.34,10,10,0,0,0-1.1-1.13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,13.65c-.16.4-.34.84-.56,1.29s-.45.89-.67,1.27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.64,
    cy: 21.42,
    r: 3.45,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotBlocked);
export default __webpack_public_path__ + "static/media/SHOT_BLOCKED.1b268a40340aa96ab09ac2bc5dec53e9.svg";
export { ForwardRef as ReactComponent };